import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "mpaylog",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", 'setting'])
  },
  data() {
    return {
      list: [],
      isLoading: false,
      total: 0,
      time: ["", ""],
      condition: {
        user_id: "",
        username: "",
        firstname: "",
        lastname: "",
        type: '-1',
        status: "",
        page: 1,
        limit: 15
      }
    };
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let rs = await this.$http.post("/mpay/logs", {
        time: this.time,
        ...this.condition
      });
      this.isLoading = false;
      if (rs.code == 0) {
        this.list = rs.data.items;
        this.total = rs.data.total;
      }
    },
    cutStr(str) {
      if (str) return str.replace("T", " ").replace(".000Z", "");
    },
    onRefresh() {
      this.getData();
    },
    onPageChange(e) {
      this.condition.page = e;
      this.getData();
    },
    onPageSizeChange(e) {
      this.condition.limit = e;
      this.getData();
    },
    onDatePickerInput(val) {
      if (val[0]) val[0] = val[0] + " 00:00:00";
      if (val[1]) val[1] = val[1] + " 23:59:59";
      console.log("onDatePickerInput", val, this.time);
    }
  },
  mounted() {
    this.getData();
  }
};